import BaseService from "@/services/BaseService";

export default class DocumentService extends BaseService {
    static async uploadDocumentChunk(organizationId: string, documentId: string, index: number, total: number, subject: string, fiscalCode: string, subReference: string, categoryId: number, data: string, notes: string) {
        return await this.perform<any>({
            url: `/portal/documents/chunks?organizationId=${organizationId}`,
            method: "POST",
            auth: true,
            body: {
                id: documentId,
                index: index,
                total: total,
                subject: subject,
                fiscalCode: fiscalCode,
                subReference: subReference,
                categoryId: categoryId,
                data: data,
                notes: notes
            }
        });
    }
}